import { render, staticRenderFns } from "./SegmentText.vue?vue&type=template&id=46b861a6"
import script from "./SegmentText.vue?vue&type=script&lang=js"
export * from "./SegmentText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports